import React from 'react';
import { App_PortalFragment, CartItemFragment, Cart_ApplicationFragment, Condition } from '../../generated.graphql';
import { parseAndFormatCurrency } from 'shared/utils/currency';
import { useItem } from './hooks';
import { NewProductDescriptionButton } from './NewProductDescription';
import { PrelovedConditionReportButton } from './PrelovedConditionReport';
import { ProtectionPlanInfo, ProtectionPlanTerms } from './ProtectionPlan';
import { ProtectionPlanCheckbox, ProtectionPlanLabelledCheckbox } from './ProtectionPlanCheckbox';
import { PurchasePricingPopoverButton } from './PurchasePricing';
import { RemoveItemBtn } from './RemoveItemBtn';
import { SuggestedItems } from './SuggestedItems';
import { ProtectionPlanLogo } from './ProtectionPlanLogo';
import { ProtectionPlanBenifits } from './ProtectionPlanBenefits';
import { MinRentalPeriod } from './RebatePeriodSelect';


interface Props {
  application: Cart_ApplicationFragment;
  portal: App_PortalFragment;
  className?: string;
  remove: boolean
}

export const CartStack = ({application, ...props}: Props) => {
  const { pricing } = application;
  return (
    <div className={props.className}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto'
      }}>
        <div className="font-weight-normal border-bottom py-2 mb-2">Items to be Rented</div>
        <div className="font-weight-normal border-bottom py-2 mb-2">Monthly Payment</div>
        
        {application.items && application.items.map(item => 
          <CartStackItem key={item.id} item={item} remove={props.remove} readonly={!!application.inStore}/>
        )}

        <div className="font-weight-normal mb-2">Regular monthly payments</div>
        <div className="text-right font-weight-normal mb-2">{parseAndFormatCurrency(pricing.ongoingPayment)}</div>
        
        <div className="font-weight-normal mb-3">Once off {application.importantInfo.freightHeading.toLowerCase()}</div>
        <div className="text-right font-weight-normal mb-3">{parseAndFormatCurrency(pricing.setupFee)}</div>
      </div>
      {application.suggestedItems && application.suggestedItems.length > 0 && (
        <div className="border-top mt-0 pt-3">
          <SuggestedItems items={application.suggestedItems} portalSlug={application.portal.slug} />
        </div>
      )}
      <div className="border shadow p-3 mt-5">
        <div className='d-flex mb-3'>
          <ProtectionPlanLogo className='mr-4 py-1'/>
          <ProtectionPlanCheckbox application={application} mode='switch' className='ml-auto'/>
        </div>
        <ProtectionPlanBenifits application={application} portalSlug={props.portal.slug}/>
      </div>
    </div>
  )
};


const CartStackItem = ({item, remove, readonly}: {item: CartItemFragment, remove: boolean, readonly: boolean}) => {
  const h = useItem({item, readonly})
  return (
    <>
      {/*<div className={cs("bg-white shadow", styles.ItemImageWidth)}>
        {item.imageUrl && <img src={item.imageUrl} className="img-fluid" alt="Item thumbnail"/>}
</div>*/}
      <div className="mb-3 pb-3 border-bottom">
        {/*<div className="font-weight-normal">{h.formattedCondition}</div>*/}
        <div className="mb-1 font-weight-normal">{item.condition === Condition.Preloved ? h.formattedCondition : ''} {h.formattedName}</div>
        <div className="mb-1">{item.subtitle}</div>
        <div className="small mb-2"><MinRentalPeriod minMonths={item.selectedRate.minMonths ?? item.minMonths}/></div>

        <div><PurchasePricingPopoverButton rate={item.selectedRate} startValue={item.startValue} className="btn btn-link px-0 py-0 btn-sm font-weight-light" caret={true} /></div>
        {item.newProductDescription && 
          <div><NewProductDescriptionButton item={item} className="btn btn-link px-0 py-0 btn-sm font-weight-light text-decoration-italic" caret={true} /></div>
        }
        {item.prelovedConditionReport &&
          <div><PrelovedConditionReportButton item={item} className="btn btn-link px-0 py-0 btn-sm font-weight-light" caret={true} /></div>
        }
      </div>
      <div className="mb-3 pb-3 border-bottom text-right pl-2">
        <div className="font-weight-normal">
          {h.formattedRate}
          {remove && (
            <RemoveItemBtn 
              disabled={h.isRemoving}
              onRemove={async () => {await h.remove()}}
              className="btn btn-link px-2"
            />
          )}
        </div>
        <h.QtySelect className="form-control custom-select">
          {item.qty > 1 ? (<div className="small mr-2">Quantity: {item.qty}</div>) : (<></>)}
        </h.QtySelect>
      </div>
    </>
  )
};
